
    import {Inject, Options, Vue} from 'vue-property-decorator';
    import {Getter} from 'vuex-class';
    import {LocationAutocomplete} from '@malt/location-autocomplete';
    import {TipsPart} from '@/profile-creation-wizard/components/for-creation/TipsPart';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import getters from '@/profile-creation-wizard/components/for-creation/store/getters';
    import type {Address, ProfileCreationForm} from '@/profile-creation-wizard/components/for-creation/store';
    import mutations from '@/profile-creation-wizard/components/for-creation/store/mutations';
    import {CreationFormValidation} from '@/profile-creation-wizard/components/for-creation/ProfileCreationForm';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {eventBusProfileCreationWizard} from '@/profile-creation-wizard/common/events';

    @Options({})
    export default class LocationSelection extends Vue {
        @Inject({from: DI.creationFormValidation})
        creationFormValidation!: CreationFormValidation;
        @Getter(getters.creationForm)
        creationForm!: ProfileCreationForm;
        $refs!: {
            location: HTMLInputElement;
        };

        bottomSheetSelector = '#details-location-bottom-sheet';
        dataHeapTooltipID = 'profile-creation-tooltip-location';
        error = false;
        focus = false;
        placesSearcher!: LocationAutocomplete;

        mounted() {
            this.placesSearcher = new LocationAutocomplete({
                input: this.$refs.location,
                layer: 'LOCALITY',
                focusPoint: window.GEOLOCATION_FOCUS_POINT,
                onSelect: (lastSelected: any) => {
                    const address = this.formatAddress(lastSelected);
                    this.updateAddress(address);
                    this.validate();
                },
            });
            this.bottomSheetDisplayer = new BottomSheetDisplayer(
                this.bottomSheetSelector,
                this.dataHeapTooltipID,
                this.$el,
                'div.profile-creation-wizard',
            );
            this.bottomSheetDisplayer.mounted();
        }

        openBottomSheet(): void {
            this.bottomSheetDisplayer.openBottomSheet();
        }

        beforeUnmount(): void {
            this.placesSearcher.destroy();
        }

        emitFocus(): void {
            this.focus = true;
            eventBusProfileCreationWizard.emit('creation:focus-changed', TipsPart.locationAndWorkplace);
        }

        validate(): void {
            if (this.$refs.location.value.trim().length === 0) {
                this.error = true;
                return;
            }

            this.error = !this.creationFormValidation.isLocationValid(this.creationForm.address);
        }

        get hasError(): boolean {
            return this.error;
        }

        private updateAddress(address: Address) {
            this.$store.commit(mutations.selectAddress, address);
            eventBusProfileCreationWizard.emit('creation:location-updated');
        }

        private formatAddress(address: any): Address {
            return {
                city: address?.city || null,
                countryCode: address?.countryCode || null,
                country: address?.country || null,
                administrativeAreaLevel1: address?.administrativeAreaLevel1 || null,
                administrativeAreaLevel1Code: address?.administrativeAreaLevel1 || null,
                administrativeAreaLevel2: address?.administrativeAreaLevel2 || address?.city || null,
                administrativeAreaLevel2Code: null,
                administrativeAreaLevel3: null,
                administrativeAreaLevel3Code: null,
                administrativeAreaLevel4: null,
                administrativeAreaLevel4Code: null,
                lon: address?.loc.lon || null,
                lat: address?.loc.lat || null,
                formattedAddress: address?.formattedAddress || null,
            };
        }
    }
